import { useState } from 'react';
import Alert from '../helpers/alert';
import { ERR_MSG } from '../globalConstants';

// Wraps an async save handler with a saving flag and the standard
// alert-on-error path, always clearing the flag once the save settles.
const useSaveAction = <Args extends unknown[]>(
  save: (...args: Args) => Promise<void>,
): [(...args: Args) => Promise<void>, boolean] => {
  const [saving, setSaving] = useState(false);

  const run = async (...args: Args) => {
    setSaving(true);
    try {
      await save(...args);
    } catch {
      Alert.error(ERR_MSG);
    } finally {
      setSaving(false);
    }
  };

  return [run, saving];
};

export default useSaveAction;
